<i
  class="icofont icofont-info-circle"
  data-bs-toggle="tooltip"
  [placement]="placement ? placement : 'top'"
  [ngbTooltip]="tipContent"
  tooltipClass="custom-tooltip"
></i>
<ng-template #tipContent>
  <span class="tipContent">{{ infoTooltip }}</span>
</ng-template>
